const module = { name: 'news/author/app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_context } from 'require-core';

const { context: { req: { params } } } = Fandango_context;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as link } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    ITEM_SELECTOR: '.content-item-container',
    MORE_BTN: '#more-button',
    WALL: '.content-item-list.wall',
}


let $moreBtn


let $container
function onImagesLoaded() {
    $container.isotope({
        itemSelector: Selectors.ITEM_SELECTOR
    });
    $(window).on('resize', $.debounce(250, () => $container.isotope()));
}
function onFetchDone(result) {
    if (result.done || !result.hasMoreArticles) {
        $moreBtn.hide();
    }
    const html = result.data.map(article => swig.render('_articleBrick', { article }));
    const $items = $(html.join('\n'));
    $items
        .addClass('hide-item')
        .appendTo($container)
        .imagesLoaded(() => {
        $container.isotope('appended', $items);
        $items.removeClass('hide-item');
        $moreBtn
            .text($moreBtn.data('text-state-default')).removeAttr('disabled')
            .data('next-page', result.nextPage);
    });
}
function onFetchFail() {
    $moreBtn.hide();
}
function onMoreBtnClick() {
    $moreBtn.text($moreBtn.data('text-state-loading')).attr('disabled', 'disabled');
    xhr.ajax({
        method: 'GET',
        url: link.napiAuthorArticlePager({
            name: params.name,
            id: params.id,
            page: $moreBtn.data('next-page')
        }),
    })
        .done(onFetchDone)
        .fail(onFetchFail);
}
function run() {
    checkDependencies(module.name, debugLog);
    $moreBtn = $(Selectors.MORE_BTN);
    $container = $(Selectors.WALL);
    $moreBtn.on('click', onMoreBtnClick);
    $container.imagesLoaded(onImagesLoaded);
}
run();
export default module.exports;